import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "@material-ui/core/Button";
import DatePicker from "react-datepicker";
import Options from "../behaviors/Options";
import ChartComponent from "./ChartComponent";
import getChartData from "../actions/getChartData";
import { getHistoricalDeviceStatistics } from "../../brhdevice/actions/brhdeviceActions";
import LoaderRequest from "../../../common/components/LoaderRequest";
import { API_URL } from "../../../utils/constants";

import { toast } from "react-toastify";

class HistoricalPlot extends React.Component {
  constructor(props) {
    super(props);
    var selectedFields = [
      { value: "dvbs2_rtp_seq_error_count", label: "RTP Sequence Error Count" },
    ];

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      historicalDeviceStats: [],
      chartData: [],
      pageData: [],
      disabledNext: true,
      disabledPrevious: true,
      selectedFields: selectedFields,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setPlotDates();
    }, 2 * 100);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.action === "FETCH_HISTORICAL_DEVICESTATS_GET_DATA_SUCCESS") {
      const historicalDeviceStats = nextProps.historicalInfo;
      this.setState(
        {
          historicalDeviceStats: historicalDeviceStats,
        },
        () => {
          this.plotChart();
        }
      );
    }
  }

  timedOutCallback = (error) => {
    if (error.code === "ECONNABORTED") {
      let message = "Error Downloading Historical Data. Request Timed Out.";
      toast(message, {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  getStats = () => {
    this.props.getHistoricalDeviceStatistics(
      this.props.selectedDevice[0].provisioned_device.mac_address,
      this.state.startDate.toISOString(),
      this.state.endDate.toISOString(),
      null, // successCallback
      this.timedOutCallback, // errorCallback
      true
    );
  };

  plotChart = () => {
    let chartData = [];
    if (this.state.selectedFields && this.state.selectedFields.length > 0) {
      let data = getChartData({
        deviceStats: this.state.historicalDeviceStats,
        selectedFields: this.state.selectedFields,
      });
      if (data) {
        chartData = data[0];
      }
    }
    this.setState(
      {
        chartData: chartData,
        pageIndex: 0,
      },
      () => {
        let page = Math.floor(
          (this.state.historicalDeviceStats.length - 1) / 20
        );
        this.getPageData(page);
      }
    );
  };

  handleFromDateChange = (date) => {
    if (date && date < new Date()) {
      this.setState({ ...this.state, startDate: date }, () => {
        this.getStats();
      });
    }
  };
  handleToDateChange = (date) => {
    if (date && date < new Date() && date >= this.state.startDate) {
      this.setState({ ...this.state, endDate: date }, () => {
        this.getStats();
      });
    }
  };

  getSelectedFields = (selectedFields) => {
    if (selectedFields) {
      selectedFields = selectedFields.slice(0, 4);
    }
    this.setState(
      {
        selectedFields: selectedFields,
      },
      () => {
        this.getStats();
      }
    );
  };

  setPlotDates = (days = 7) => {
    let startDate = new Date();
    startDate.setDate(startDate.getDate() - days);
    // this.handleFromDateChange(startDate);
    this.setState({ startDate: startDate, endDate: new Date() }, () => {
      this.getStats();
    });
  };

  getPageData = (page) => {
    let byPoints = 20;
    let pageIndex = this.state.pageIndex + page;
    let pointIndex = pageIndex * byPoints;
    let data = this.state.chartData.slice(1);

    if (pointIndex <= data.length) {
      if (pointIndex >= 0) {
        let pageData = data.slice(pointIndex, pointIndex + byPoints);
        pageData.splice(0, 0, this.state.chartData[0]);
        this.setState(
          {
            pageData: pageData,
            pageIndex: pageIndex,
            disabledNext: false,
            disabledPrevious: false,
          },
          () => {
            this.getTicks(pageData.slice(1));
          }
        );
      }
      if (pageIndex === 0) {
        this.setState({ disabledPrevious: true });
      }
    }
    if (pointIndex + byPoints >= this.state.chartData.length - 1) {
      this.setState({ disabledNext: true });
    }
  };

  handleDownload = (startDate, endDate, mac_address) => {
    toast.info(`Downloading Historical Data`, { autoClose: 5000 });
    const url = `${API_URL}/frontend/devices/${mac_address}/stats/?stats_after=${startDate}&stats_before=${endDate}&csv=1`;

    // Open CSV download directly in a new tab
    window.open(url, "_blank");
  };

  getTicks = (pageData) => {
    let ticks = [];
    for (let i = 0; i < pageData.length; i += 6) {
      ticks.push(pageData[i][0]);
    }
    if (
      pageData.length > 0 &&
      !ticks.includes(pageData[pageData.length - 1][0])
    ) {
      ticks.push(pageData[pageData.length - 1][0]);
    }
    this.setState({
      ticks: ticks,
    });
  };

  render() {
    return (
      <div>
        <h2 style={{ textAlign: "center" }}>Historical Data</h2>
        <div className="col-sm-12 drop-margin">
          <Options
            getSelected={this.getSelectedFields}
            defaultValue={this.props.defaultValue}
            deviceSource={this.props.deviceSource}
          ></Options>
        </div>
        <br />
        <div className="btn-contain">
          <div
            className="filter-dataleft"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            {/*start Date Picker */}
            <div
              style={{
                position: "relative",
                display: "inline-block",
                minWidth: "280px",
                marginLeft: "2px",
              }}
            >
              <div
                style={{
                  marginBottom: "4px",
                  fontWeight: "bold",
                  display: "inline-block",
                }}
              >
                Start
              </div>
              <DatePicker
                className="form-control filterdate-plotchar"
                selected={this.state.startDate}
                placeholderText="Plot From Date"
                onChange={this.handleFromDateChange}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={7}
                dateFormat="MMMM d, yyyy h:mm aa"
                timeCaption="Time"
                dropdownMode="select"
                minDate={
                  this.state.endDate
                    ? new Date(
                        this.state.endDate.getTime() - 15 * 24 * 60 * 60 * 1000
                      )
                    : new Date()
                }
                maxDate={this.state.endDate || new Date()}
                popperPlacement="bottom-start"
                popperModifiers={[
                  { name: "offset", options: { offset: [0, 5] } },
                ]}
                calendarContainer={({ children }) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "8px",
                      background: "#fff",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  >
                    {children}
                  </div>
                )}
              />
            </div>

            {/*end Date Picker */}
            <div
              style={{
                position: "relative",
                display: "inline-block",
                minWidth: "280px",
                marginLeft: "2px",
              }}
            >
              <div
                style={{
                  marginBottom: "4px",
                  fontWeight: "bold",
                  display: "inline-block",
                }}
              >
                End
              </div>
              <DatePicker
                className="form-control filterdate-plotchar"
                selected={this.state.endDate}
                placeholderText="Plot Till Date"
                onChange={this.handleToDateChange}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={7}
                dateFormat="MMMM d, yyyy h:mm aa"
                timeCaption="Time"
                dropdownMode="select"
                minDate={this.state.startDate}
                maxDate={
                  this.state.startDate
                    ? new Date(
                        this.state.startDate.getTime() +
                          15 * 24 * 60 * 60 * 1000
                      )
                    : null
                }
                disabled={!this.state.startDate}
                popperPlacement="bottom-start"
                popperModifiers={[
                  { name: "offset", options: { offset: [0, 5] } },
                ]}
                calendarContainer={({ children }) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "8px",
                      background: "#fff",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  >
                    {children}
                  </div>
                )}
              />
            </div>

            {/* Buttons */}
            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <Button
                variant="contained"
                className="filterdate-plotchar"
                color="primary"
                onClick={this.getStats}
              >
                Plot Chart
              </Button>
              <Button
                className="filterdate-plotchar"
                variant="contained"
                color="primary"
                onClick={() => this.setPlotDates(1)}
              >
                last 1 Day
              </Button>
              <Button
                className="filterdate-plotchar"
                variant="contained"
                color="primary"
                onClick={() => this.setPlotDates(7)}
              >
                last 7 Days
              </Button>
              <Button
                className="filterdate-plotchar"
                variant="contained"
                color="primary"
                onClick={() => this.setPlotDates(15)}
              >
                last 15 Days
              </Button>
            </div>
          </div>

          <LoaderRequest />

          <button
            type="button"
            className="btn btn-outline-secondary"
            style={{ padding: "10px", marginTop: "10px" }}
            onClick={() =>
              this.handleDownload(
                this.state.startDate.toISOString(),
                this.state.endDate.toISOString(),
                this.props.selectedDevice[0].provisioned_device.mac_address
              )
            }
          >
            Download Historical CSV{" "}
            <span className="glyphicon glyphicon-download-alt"></span>
          </button>

          {this.state.disabledPrevious && null}
          {this.state.disabledNext && null}
        </div>

        {this.state.chartData.length > 0 ? (
          <ChartComponent
            ticks={this.state.ticks}
            chartData={this.state.pageData}
          />
        ) : (
          <div />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    historicalInfo: state.brhDevicesInfo.historicalInfo,
    action: state.brhDevicesInfo.action,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getHistoricalDeviceStatistics,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoricalPlot);
